import { render, staticRenderFns } from "./taskInstanceView.vue?vue&type=template&id=b21864d0&"
import script from "./taskInstanceView.vue?vue&type=script&lang=js&"
export * from "./taskInstanceView.vue?vue&type=script&lang=js&"
import style0 from "./taskInstanceView.vue?vue&type=style&index=0&id=b21864d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports